import {Box, Flex} from '@chakra-ui/react';
import {FC} from 'react';
import LinkUI from 'ui/LinkUI';
import NextImageUI from 'ui/NextImage';

interface IProps {
  isDesktop: boolean;
}

export const Logo: FC<IProps> = ({isDesktop}) => {
  const logo_desktop = '/straus-logo.svg';

  return (
    <LinkUI href="/">
      <Flex flexDirection="column">
        <Flex alignItems="center">
          {isDesktop ? (
            <NextImageUI width={146} height={45} src={logo_desktop} alt="Straus.md logo" />
          ) : (
            <Box w="25px" h="46px">
              <NextImageUI
                width={25}
                height={29}
                src="/straus_mobile_logo_part1.svg"
                alt="Straus.md logo"
                style={{
                  width: '25px',
                  height: '29px',
                }}
              />
              <Box w="25px">
                <NextImageUI
                  height={20}
                  width={15}
                  src="/straus_mobile_logo_part2.svg"
                  alt="Straus.md logo"
                  style={{width: '15px', height: '20px'}}
                />
              </Box>
            </Box>
          )}
        </Flex>
      </Flex>
    </LinkUI>
  );
};
